import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import {
	PRISM_DIALOG_DATA,
	PrismButtonComponent,
	PrismDialogComponent,
	PrismDialogRef
} from '@shure/prism-angular-components';

import { ConfirmDialog } from '../../models/elevated-access.model';

@Component({
	selector: 'sh-confirm-dialog',
	imports: [CommonModule, TranslocoModule, PrismDialogComponent, PrismButtonComponent],
	templateUrl: './confirm-dialog.component.html',
	styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {
	constructor(
		private dialogRef: PrismDialogRef<ConfirmDialogComponent>,
		@Inject(PRISM_DIALOG_DATA)
		public readonly dialogData: ConfirmDialog
	) {}

	public closeDialog(): void {
		this.dialogRef.close({ confirmed: false });
	}

	public confirmAction(): void {
		this.dialogRef.close({ confirmed: true });
	}
}
